import { render, staticRenderFns } from "./RestaurantMapPopover.vue?vue&type=template&id=15214a8a&scoped=true&"
import script from "./RestaurantMapPopover.vue?vue&type=script&lang=js&"
export * from "./RestaurantMapPopover.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantMapPopover.vue?vue&type=style&index=0&id=15214a8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15214a8a",
  null
  
)

export default component.exports